export default __webpack_public_path__ + "static/media/clairefontaine18.3d3b0cf6.jpg";